import { useMemo } from 'react';
import { useMarketplaceConfig } from '../queries/marketplace';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { LanguageConfig, LanguageOption } from '../@types';

export const useAvailableLanguages = (): LanguageOption[] => {
  const { data: marketplaceConfig } = useMarketplaceConfig();
  const languageConfiguration = useFeatureValue<LanguageConfig | null>('language-configuration', null);

  const supportedLanguages = marketplaceConfig?.marketplaceConfig?.languageConfig?.supportedLanguages;

  return useMemo(() => {
    if (!languageConfiguration || !supportedLanguages) return [];
    return languageConfiguration.filter((lang) => supportedLanguages.includes(lang.key));
  }, [languageConfiguration, supportedLanguages]);
};
